"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGenerateContextResponse = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
function isGenerateContextResponse(value) {
    return value != null && typeof value === 'object' && typeof value.keyId === 'string';
}
exports.isGenerateContextResponse = isGenerateContextResponse;
